export function stampToDate(stamp?: number | null): Date | null {
  if (!stamp || stamp <= 0) return null;
  const s = String(Math.trunc(stamp)).padStart(14, '0');
  const d = new Date(Date.UTC(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8), +s.slice(8, 10), +s.slice(10, 12), +s.slice(12, 14)));
  return Number.isNaN(d.getTime()) ? null : d;
}
export function formatStamp(stamp?: number | null, fallback = 'never'): string {
  const d = stampToDate(stamp);
  return d ? d.toLocaleString() : fallback;
}
export function formatRelative(stamp?: number | null, fallback = 'never'): string {
  const d = stampToDate(stamp);
  if (!d) return fallback;
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return 'just now';
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}
/** Anatomy sends "Y-m-d H:i:s"; render it in the browser's locale without a timezone shift. */
export function formatAnatomyDateTime(value?: string | null): string {
  if (!value) return '';
  const d = new Date(value.replace(' ', 'T'));
  return Number.isNaN(d.getTime()) ? value : d.toLocaleString();
}
